import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
`

export const header = css`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing(10)};

  &.emptyMessage {
    margin-bottom: ${spacing(6)};
  }
`

export const title = css`
  ${font_lg};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const updateButton = css`
  display: flex;
  align-items: center;
`

export const updateIcon = css`
  transform: scale(0.7);
  margin-left: ${spacing(1)};
`

export const syncStatus = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  display: flex;
  align-items: center;
`

export const syncStatusText = css`
  margin-right: ${spacing(1)};
`

export const agentSection = css`
  margin-bottom: ${spacing(6)};
`

export const emptyMessage = css`
  ${font_lg};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const expenseDetailsContainer = css`
  & > :nth-child(n + 2) {
    margin-top: ${spacing(10)};
  }
`

export const expenseDetailsList = css`
  display: flex;
  flex-direction: column;
  & > :nth-child(n + 2) {
    margin-top: ${spacing(5)};
  }
`

export const skeletonTitle = css`
  margin-bottom: ${spacing(5)};
  width: 50%;
  height: 24px;
`

export const skeletonCategory = css`
  width: 25%;
  height: 20px;
`

export const skeletonLabel = css`
  width: 66%;
  height: 16px;
`
